export default __webpack_public_path__ + "static/media/user-check.b1138938.svg";